<script setup lang="ts">
import { computed, ref } from 'vue';
import { useDepartmentStore } from '@/stores/department';
import { hexToRgbA } from '@/utils/helpers';
import { DepartmentFragment } from '@/graphql/custom-types';

const departmentStore = useDepartmentStore();

interface Props {
  selectedDepartment?: DepartmentFragment;
  departments?: DepartmentFragment[];
}

const props = withDefaults(defineProps<Props>(), {});

const showOptions = ref<boolean>(false);
const showDepartmentsList = ref<boolean>(false);

const department = computed(() => {
  return props.selectedDepartment || departmentStore;
});

const onClickoutside = () => {
  if (!showDepartmentsList.value) return;
  showDepartmentsList.value = false;
};
</script>

<template>
  <div class="departmentSwitcherContainer flex justify-center pb-8">
    <div
      class="relative"
      v-clickoutside="{
        excludeString: '.options, .options>*, .selection, .selection>*',
        handler: onClickoutside,
      }"
    >
      <div class="bg-neutral-0 shadow-screenMedium rounded-full h-[80px]">
        <button
          class="w-[367px] flex selection items-center justify-between z-75 pl-2 pr-4 rounded-full h-full"
          @click="showOptions = !showOptions"
        >
          <div
            class="w-[64px] h-[64px] rounded-full flex items-center justify-center"
            :style="{
              backgroundColor: hexToRgbA(department?.color || '', 0.2),
            }"
          >
            <div
              class="flex items-center justify-center rounded-full"
              :style="{
                backgroundColor: department?.color || '',
                height: '40px',
                width: '40px',
              }"
            >
              <fa-icon class="text-xl text-white" :icon="['fas', 'home']" />
            </div>
          </div>
          <p class="h700">
            {{ department.name }}
          </p>

          <div class="items-center">
            <fa-icon
              class="text-lg"
              :icon="['far', showOptions ? 'chevron-up' : 'chevron-down']"
            />
          </div>
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.departmentSwitcherContainer {
  .options {
    .option {
      height: 96px;
    }
  }
}
</style>
